export default __webpack_public_path__ + "static/media/img_main.71630c95.png";